module.exports = __webpack_public_path__ + "static/media/google-play-button.83db2e0a.svg";